// extracted by mini-css-extract-plugin
export default {"wrapper":"overview-tab_wrapper__Dr15A"};